import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Button from '../components/button'
import Hero17 from '../components/hero17'
import Features24 from '../components/features24'
import CTA26 from '../components/cta26'
import CTA9 from '../components/cta9'
import Features25 from '../components/features25'
import Features241 from '../components/features241'
import Steps2 from '../components/steps2'
import Testimonial17 from '../components/testimonial17'
import Features18 from '../components/features18'
import Contact7 from '../components/contact7'
import Gallery141 from '../components/gallery141'
import Footer4 from '../components/footer4'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>
          Personal Training for Busy Professionals Over 40 | Adrian Tan Fitness
        </title>
        <meta
          name="description"
          content="Private 1-to-1 personal training in Singapore with Adrian Tan, 2× Mr Singapore. Get stronger, lose body fat and stay injury-free with intelligent, efficient and highly personalised training for busy professionals over 40."
        />
        <meta
          property="og:title"
          content="Personal Training for Busy Professionals Over 40 | Adrian Tan Fitness"
        />
        <meta
          property="og:description"
          content="Private 1-to-1 personal training in Singapore with Adrian Tan, 2× Mr Singapore. Get stronger, lose body fat and stay injury-free with intelligent, efficient and highly personalised training for busy professionals over 40."
        />
      </Helmet>
      <img alt="image" src="/logo-200h.png" className="home-image" />
      <h1 className="home-text100 thq-heading-1">
        <span>Personal Training for Busy Professionals Over 40</span>
      </h1>
      <h2 className="home-text104 thq-body-large">
        <span>Get Stronger. Lose Body Fat. Stay Injury-Free.</span>
        <br></br>
      </h2>
      <p className="home-text107 thq-body-large">
        <span>
          Private 1-to-1 personal training in Singapore with Adrian Tan, 2×
          Mr Singapore.
        </span>
        <br></br>
      </p>
      <p className="home-text107 thq-body-large">
        <span>
          With over 20 years of experience, I help busy professionals build
          stronger, leaner and healthier bodies through intelligent,
          efficient and highly personalised training.
        </span>
        <br></br>
        <br></br>
        <span>
          You don’t need to spend your life in the gym. You need the right
          training, performed consistently, with the right guidance.
        </span>
      </p>
      <a href="#Contact7" className="home-link">
        <Button
          action1={
            <Fragment>
              <span className="home-text110">Book a Private Consultation</span>
            </Fragment>
          }
          buttonId="Button"
          rootClassName="buttonroot-class-name"
          className="home-component10"
        ></Button>
      </a>
      <Hero17
        hero17Id="Hero17"
        image1Src="/square_001-1500w.jpeg"
        image2Src="/square_003-1500w.jpeg"
        image3Src="/square_002-1500w.jpeg"
        image4Src="/square_017-1500w.jpeg"
        image5Src="/square_007-1500w.jpeg"
        image7Src="/square_005-1500w.jpeg"
        image8Src="/square_016-1500w.jpeg"
        image9Src="/square_014-1500w.jpeg"
        image10Src="/img_8455-1500w.jpeg"
        image11Src="/square_006-1500w.jpeg"
        rootClassName="hero17root-class-name"
      ></Hero17>
      <Features24
        feature1Title={
          <Fragment>
            <span className="home-text111">
              Meet Your Trainer — Adrian Tan
            </span>
          </Fragment>
        }
        feature1ImgSrc="/square_004-1400w.jpeg"
        feature1Description={
          <Fragment>
            <span className="home-text112">
              2× Mr Singapore | Personal Trainer | 30+ Years Experience. I’ve
              spent more than two decades helping people transform their
              bodies and improve their physical performance.
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text113">
              But my approach to personal training isn’t about making every
              client train like a competitive bodybuilder. Your training
              should be designed for your life. I work with busy
              professionals, business leaders and individuals who want
              excellent results but don’t have unlimited time to spend in
              the gym.
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text114">
              <span>
                Every program is built around the individual—your goals,
                physical condition, training experience, lifestyle and
                limitations. My objective is simple: maximum results from
                intelligent, efficient training. Not endless workouts. Not
                unnecessary exercises. Training with a purpose.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
      ></Features24>
      <CTA26
        action1={
          <Fragment>
            <span className="home-text117">Show Client Transformations</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text118">
              The goal isn’t simply to look better. It’s to become stronger,
              leaner, healthier and more capable—and maintain those results
              for years, through consistent training, sensible progression
              and an approach designed around the client’s lifestyle.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text119">Real Clients. Real Results.</span>
          </Fragment>
        }
        action1Url="#Gallery141"
        rootClassName="cta26root-class-name"
      ></CTA26>
      <Features25
        feature1Title={
          <Fragment>
            <span className="home-text127">Personalised Training</span>
          </Fragment>
        }
        feature1ImgSrc="/dsc_9101_2-1400w.jpeg"
        feature1Description={
          <Fragment>
            <span className="home-text128">
              Your program is designed around your goals, ability, training
              history and lifestyle—not copied from a generic workout
              template. Every client is different. Their training should be
              too.
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text129">
              <span>
                Strength &amp; Longevity: build and maintain the strength and
                muscle that become increasingly important as you get older.
              </span>
              <br></br>
              <br></br>
              <span>
                Accountability matters too—knowing what to do is only part of
                achieving results. I’ll help keep your training structured,
                progressive and moving toward your goals.
              </span>
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text130">
              <span>
                Body Composition: improve the ratio of muscle to body fat
                through structured resistance training and sustainable
                lifestyle habits.
              </span>
              <br></br>
              <br></br>
              <span>
                Injury Prevention: training should make your body more
                capable—not constantly leave you injured. Exercise selection,
                technique and progression are carefully managed around your
                individual needs.
              </span>
            </span>
          </Fragment>
        }
      ></Features25>
      <Features241
        feature1Title={
          <Fragment>
            <span className="home-text134">
              <span>
                Train Smarter. Not Just Harder.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        features241Id="Features241"
        feature1ImgSrc="/img_6649-1400w.jpeg"
        feature1Description={
          <Fragment>
            <span className="home-text137">
              More isn’t always better. My training philosophy is based on
              finding the minimum effective dose required to create maximum
              sustainable results—concentrating on what actually produces
              results and eliminating unnecessary work.
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text138">
              Every exercise should have a reason. Every progression should
              have a purpose. And every training session should move you
              closer to your goal.
            </span>
          </Fragment>
        }
      ></Features241>
      <Steps2
        heading1={
          <Fragment>
            <span className="home-text146">Starting Is Simple</span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span className="home-text147">Book Your Private Consultation</span>
          </Fragment>
        }
        action1Url="#Contact7"
        step1Description={
          <Fragment>
            <span className="home-text139">
              <span>
                Book a Private Consultation. We’ll discuss your goals,
                training history, lifestyle and what has prevented you from
                getting the results you want.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        step2Description={
          <Fragment>
            <span className="home-text142">
              <span>
                Establish Your Starting Point. I’ll assess where you are now
                and determine the most appropriate training approach. Your
                training will be structured around your goals, ability and
                schedule.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        step3Description={
          <Fragment>
            <span className="home-text145">
              <span>
                Start Training. We’ll train consistently, monitor your
                progress and adjust the program as you improve.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
      ></Steps2>
      <Testimonial17
        review1={
          <Fragment>
            <span className="home-text148">
              I’ve been training with Adrian for 6 years and I enjoy his style
              which is tailored for me and I have seen many benefits both in
              fitness and health.
            </span>
          </Fragment>
        }
        review2={
          <Fragment>
            <span className="home-text149">
              Adrian has been a great partner and trainer, keeping me on point
              and makes sure the exercises are age appropriate and keeps me
              injury free.
            </span>
          </Fragment>
        }
        review3={
          <Fragment>
            <span className="home-text150">
              Adrian is an awesome trainer and always provides excellent support
              during sessions.
            </span>
          </Fragment>
        }
        review4={
          <Fragment>
            <span className="home-text151">
              With the exceptional guidance of Adrian, I’ve progressively gotten
              stronger and remain injury-free. He cares about my well being and
              progress. His customized training regimen prepared me for the
              Boston Marathon in 2024!
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text152">
              <span>
                Coaching people who expect high standards. Over the years,
                I’ve had the privilege of training senior executives, business
                leaders, professionals, doctors and athletes.
              </span>
              <br></br>
              <br></br>
              <span>
                They have demanding careers and limited time. Their training
                needs to be efficient, personalised and effective. So does
                yours.
              </span>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text160">Trusted by Professionals</span>
          </Fragment>
        }
        review31={
          <Fragment>
            <span className="home-text161">
              It has been a pleasure training with Adrian. He is knowledgeable,
              professional and very motivating. I always look forward to the
              next session!
            </span>
          </Fragment>
        }
        review41={
          <Fragment>
            <span className="home-text162">
              Adrian is a fantastic coach who knows what he’s doing and helped
              me reach my fitness goals injury free. He is focused on results
              and yet empathetic to the lifestyle of a busy executive.
            </span>
          </Fragment>
        }
        review413={
          <Fragment>
            <span className="home-text163">
              Have been training with Adrian for more than a year and have lost
              14kg of body fat. He has personalized my workouts based on my
              goals and also taking into account that I have some pre existing
              injuries. He is a positive and inspirational trainer!
            </span>
          </Fragment>
        }
        review414={
          <Fragment>
            <span className="home-text164">
              Been training with Adrian for many years! He’s a patient and
              attentive trainer.
            </span>
          </Fragment>
        }
        review415={
          <Fragment>
            <span className="home-text165">
              Great no nonsense training with Adrian for many years! Results
              speak for themselves.
            </span>
          </Fragment>
        }
        author1Src="/ray%20ferguson-200h.jpeg"
        author2Src="/jason%20moo-200h.jpeg"
        author3Src="/john%20lombard-200h.jpeg"
        author4Src="/ramesh%20selvaraj-200h.jpeg"
        review4131={
          <Fragment>
            <span className="home-text166">
              <span>
                Adrian&apos;s personalized workout plans have been a
                game-changer. I can see and feel the difference in my fitness
                and body fat composition. Adrian is a hands-on, careful trainer
                who calibrates his workout plans such that they sufficiently
                challenge me without pushing me beyond my limits or causing
                injury. I have no hesitation in recommending Adrian as a highly
                skilled and dedicated pe trainer.
              </span>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        review4132={
          <Fragment>
            <span className="home-text170">
              I look forward to training with Adrian every time. He keeps things
              simple, safe yet effective. In my years of training with him, I
              have not had a single injury. Training for longevity with Adrian
              is key to my continued active lifestyle.
            </span>
          </Fragment>
        }
        review4133={
          <Fragment>
            <span className="home-text171">
              Adrian designed a program that gradually escalates / minimise risk
              of injury and perhaps most importantly can become a life long
              habit. Not only do I feel better but Adrian has become a friend -
              cheering me on and pushing me when my motivation flags. Who could
              ask for more!
            </span>
          </Fragment>
        }
        author1Name={
          <Fragment>
            <span className="home-text172">Ray Ferguson</span>
          </Fragment>
        }
        author2Name={
          <Fragment>
            <span className="home-text173">Jason Moo</span>
          </Fragment>
        }
        author3Name={
          <Fragment>
            <span className="home-text174">
              John Lombard
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        author3Src1="/sathiaseelan-200h.jpeg"
        author4Name={
          <Fragment>
            <span className="home-text175">Ramesh Selvaraj</span>
          </Fragment>
        }
        author4Src1="/eugene%20chang-200h.jpeg"
        author3Name1={
          <Fragment>
            <span className="home-text176">Sathiaseelan J.</span>
          </Fragment>
        }
        author4Name1={
          <Fragment>
            <span className="home-text177">Eugene Chang</span>
          </Fragment>
        }
        author4Src12="/joseph%20lum-200h.jpeg"
        author4Src13="/shaila%20tanwani-200h.jpeg"
        author4Src14="/mark%20goh-200h.jpeg"
        author4Src15="/simon%20dale-200h.jpeg"
        author4Name13={
          <Fragment>
            <span className="home-text178">Shaila Tanwani</span>
          </Fragment>
        }
        author4Name14={
          <Fragment>
            <span className="home-text179">Mark Go</span>
          </Fragment>
        }
        author4Name15={
          <Fragment>
            <span className="home-text180">Simon Dale</span>
          </Fragment>
        }
        author4Src131="/samuel-chacko-200h.jpeg"
        author4Src132="/chua-soo-yong-200h.jpeg"
        author4Src133="/vikram-chakravarty-200h.jpeg"
        author4Name131={
          <Fragment>
            <span className="home-text181">
              Samuel Chacko
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        author4Name132={
          <Fragment>
            <span className="home-text182">
              Chua Soo Yong
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        author4Name133={
          <Fragment>
            <span className="home-text183">Vikram Chakravarty</span>
          </Fragment>
        }
        author1Position={
          <Fragment>
            <span className="home-text184">
              Renowned Financial Services Chief Executive
            </span>
          </Fragment>
        }
        author2Position={
          <Fragment>
            <span className="home-text185">CEO, Bank of Singapore</span>
          </Fragment>
        }
        author3Position={
          <Fragment>
            <span className="home-text186">CEO, APAC @NTT</span>
          </Fragment>
        }
        author4Position={
          <Fragment>
            <span className="home-text187">
              Partner, Allen &amp; Gledhill LLP
            </span>
          </Fragment>
        }
        author3Position1={
          <Fragment>
            <span className="home-text188">
              Partner, Allen &amp; Gledhill LLP
            </span>
          </Fragment>
        }
        author4Position1={
          <Fragment>
            <span className="home-text189">
              CEO, Leadership Choices PTE LTD
            </span>
          </Fragment>
        }
        author4Position13={
          <Fragment>
            <span className="home-text190">The Royal Group</span>
          </Fragment>
        }
        author4Position14={
          <Fragment>
            <span className="home-text191">VP, Group Property, Singtel</span>
          </Fragment>
        }
        author4Position15={
          <Fragment>
            <span className="home-text192">Advisor &amp; Investor, TPG</span>
          </Fragment>
        }
        author4Position131={
          <Fragment>
            <span className="home-text193">Director at Legis Point LLC</span>
          </Fragment>
        }
        author4Position132={
          <Fragment>
            <span className="home-text194">
              Consultant Spine and Orthopaedic Surgeon
            </span>
          </Fragment>
        }
        author4Position133={
          <Fragment>
            <span className="home-text195">
              Partner - ASEAN, Ernst &amp; Young
            </span>
          </Fragment>
        }
        author5Src="/dr%20suresh%20nair-200h.jpg"
        author5Name={
          <Fragment>
            <span className="home-text220">Dr Suresh Nair</span>
          </Fragment>
        }
        author5Position={
          <Fragment>
            <span className="home-text221">
              Senior Consultant, Obstetrician &amp; Gynaecologist
            </span>
          </Fragment>
        }
        review5={
          <Fragment>
            <span className="home-text222">
              Training with Adrian has been beneficial for fitness goals.
              Having a hectic schedule, Adrian knows how to plan and
              accommodate a productive training routine for me.
            </span>
          </Fragment>
        }
        author6Src="/dimple%20aswani-200h.jpeg"
        author6Name={
          <Fragment>
            <span className="home-text223">Dimple Aswani</span>
          </Fragment>
        }
        author6Position={
          <Fragment>
            <span className="home-text224">Director, Royal Group</span>
          </Fragment>
        }
        review6={
          <Fragment>
            <span className="home-text225">
              Training with Adrian kept me fit, improved my body composition
              while staying injury free.
            </span>
          </Fragment>
        }
        author7Src="/mike%20kasem-200h.jpeg"
        author7Name={
          <Fragment>
            <span className="home-text226">Mike Kasem</span>
          </Fragment>
        }
        author7Position={
          <Fragment>
            <span className="home-text227">
              Prominent Radio Presenter, Television Presenter &amp; Actor,
              Mediacorp
            </span>
          </Fragment>
        }
        review7={
          <Fragment>
            <span className="home-text228">
              Been training with Adrian for more than 10 years &amp; loving
              it.
            </span>
          </Fragment>
        }
        author8Src="/glenn%20ong-200h.jpeg"
        author8Name={
          <Fragment>
            <span className="home-text229">Glenn Ong</span>
          </Fragment>
        }
        author8Position={
          <Fragment>
            <span className="home-text230">
              Prominent Radio Presenter, Kiss92FM
            </span>
          </Fragment>
        }
        review8={
          <Fragment>
            <span className="home-text231">
              Adrian is the only person I trust!
            </span>
          </Fragment>
        }
        author9Src="/luke%20guanlao-200h.jpeg"
        author9Name={
          <Fragment>
            <span className="home-text232">Luke Guanlao</span>
          </Fragment>
        }
        author9Position={
          <Fragment>
            <span className="home-text233">
              Anytime Fitness Asia Co-Owner and CEO
            </span>
          </Fragment>
        }
        review9={
          <Fragment>
            <span className="home-text234">
              With Adrian’s guidance and direction I was able to improve in
              my bodybuilding goals while maintaining time with work and
              family.
            </span>
          </Fragment>
        }
      ></Testimonial17>
      <Features18
        feature1Title={
          <Fragment>
            <span className="home-text196">
              <span>Your Body Changes After 40. Your Training Should Too.</span>
              <br></br>
            </span>
          </Fragment>
        }
        feature1ImageSrc="/dsc_9057-1400w.jpeg"
        feature1Description={
          <Fragment>
            <span className="home-text199">
              <span>
                Maybe you used to be fitter. Maybe work and family gradually
                took priority. Maybe you’re gaining body fat more easily,
                losing strength or finding that your body doesn’t recover
                the way it did 10 or 20 years ago.
              </span>
              <br></br>
              <br></br>
              <span>
                Or perhaps you’re already training—but you’re no longer
                seeing the results you expect. You don’t necessarily need
                more exercise. You need better exercise.
              </span>
              <br></br>
              <br></br>
              <span>
                My approach focuses on building and maintaining: strength,
                lean muscle, healthy body composition, mobility, fitness,
                physical resilience and long-term health—all while working
                around your lifestyle, training history and individual
                needs.
              </span>
              <br></br>
              <br></br>
              <span>
                Don’t just take my word for it, because I live and breathe it!
              </span>
            </span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span className="home-text235">Start Your Journey</span>
          </Fragment>
        }
        action1Url="#Contact7"
        features18Id="Features18"
      ></Features18>
      <div className="home-fit-section thq-section-padding">
        <div className="home-fit-max-width thq-section-max-width">
          <h2 className="thq-heading-2">Is This Right for You?</h2>
          <p className="thq-body-large">
            My personal training may be a good fit if:
          </p>
          <ul className="home-fit-list thq-body-small">
            <li>
              You’re 40 or above and want to become stronger and fitter.
            </li>
            <li>
              You’re a busy professional and need your training to be
              efficient.
            </li>
            <li>
              You want to lose body fat while maintaining or building muscle.
            </li>
            <li>
              You haven’t trained consistently for years and want to start
              again properly.
            </li>
            <li>
              You’re already exercising but aren’t getting the results you
              expect.
            </li>
            <li>
              You want to train hard without unnecessarily damaging your
              joints.
            </li>
            <li>You value experienced, highly personalised coaching.</li>
            <li>
              You’re looking for sustainable results rather than another
              short-term fitness challenge.
            </li>
          </ul>
          <p className="thq-body-large">
            I work with a limited number of private 1-to-1 clients so I can
            maintain a high standard of coaching.
          </p>
          <div className="home-fit-actions">
            <a href="#Contact7" className="thq-button-filled">
              <span className="thq-body-small">
                Book a Private Consultation
              </span>
            </a>
          </div>
        </div>
      </div>
      <CTA9
        heading1={
          <Fragment>
            <span className="home-text120">
              <span>Your Strongest Years Don’t Have to Be Behind You.</span>
              <br></br>
            </span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span className="home-text123">Book Your Private Consultation</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text124">
              <span>
                Being in your 40s, 50s or beyond doesn’t mean accepting
                declining strength, increasing body fat and poorer physical
                capability. With intelligent training and consistency, you
                can continue becoming stronger, leaner and more physically
                capable.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
      ></CTA9>
      <Contact7
        content1={
          <Fragment>
            <span className="home-text210">
              The only and best investment you can make for your health. Adrian
              Tan Fitness is the best place to invest in your lifelong health
              and achieve incredible results!
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text211">
              Enquire now
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        location1ImageSrc="/square_005-1500w.jpeg"
        location11={
          <Fragment>
            <span className="home-text212">Unstoppable Fitness</span>
          </Fragment>
        }
        location1Description1={
          <Fragment>
            <span className="home-text213">
              #03-06 Shenton House, Singapore 068805
            </span>
          </Fragment>
        }
        location22={
          <Fragment>
            <span className="home-text214">What&apos;s App</span>
          </Fragment>
        }
        location2Description2={
          <Fragment>
            <span className="home-text215">
              Feel free to contact me via whatsapp
            </span>
          </Fragment>
        }
        location2Description12={
          <Fragment>
            <span className="home-text216">Chat on What&apos;s App</span>
          </Fragment>
        }
        location1ImageSrc1="/square_005-1500w.jpeg"
        location2ImageSrc1="/square_002-1500w.jpeg"
        contact7Id="Contact7"
      ></Contact7>
      <Gallery141
        gallery141Id="Gallery141"
        heading1={
          <Fragment>
            <span className="home-text217">Client Transformations</span>
          </Fragment>
        }
        image1Src="/before-after-01-600w.jpg"
        image2Src="/before-after-02-600w.jpg"
        image3Src="/before-after-03-600w.jpg"
        image1Src1="/before-after-04-600w.jpg"
        image2Src1="/before-after-11-600w.jpg"
        image2Src2="/before-after-08-600w.jpg"
        image2Src3="/before-after-05-600w.jpg"
        image3Src1="/before-after-06-600w.jpg"
        image1Src11="/before-after-10-600w.jpg"
        image1Src12="/before-after-07-600w.jpg"
        image3Src11="/before-after-12-600w.jpg"
        image3Src12="/before-after-09-600w.jpg"
        image1Src13="/before-after-13-600w.jpg"
        image2Src4="/before-after-14-600w.jpg"
        image3Src13="/before-after-15-600w.jpg"
        image1Src14="/before-after-16-600w.jpg"
        image2Src5="/before-after-17-600w.jpg"
        image3Src14="/before-after-18-600w.jpg"
      ></Gallery141>
      <Footer4></Footer4>
    </div>
  )
}

export default Home
